import * as React from 'react';

export type OnUpdateEvent = () => void;

interface ISubscriber {
    comp?: React.Component;
    onUpdate: OnUpdateEvent;
}

export abstract class SubscriberService<ServiceType> {
    private _subscribedComponents: ISubscriber[] = [];
    private _subscribedReactObservers: React.Dispatch<void>[] = [];

    constructor() {
        setTimeout(() => this.Initialized());
    }

    protected Initialized() {

    }

    public _RegisterComponent(comp?: React.Component, onUpdate?: OnUpdateEvent): ServiceType {
        if (comp && !onUpdate) {
            onUpdate = () => comp.setState({});
        }

        if (comp || onUpdate) {
            this._subscribedComponents.push({ comp, onUpdate });
        }

        return this as unknown as ServiceType;
    }

    public UnregisterComponent(comp: React.Component) {
        if (comp) {
            for (let i = 0; i < this._subscribedComponents.length; ++i) {
                if (this._subscribedComponents[i].comp === comp) {
                    this._subscribedComponents.splice(i, 1);
                }
            }
        }
    }

    protected _UpdateSubscribers() {
        for (const subscribedComponent of this._subscribedComponents) {
            subscribedComponent.onUpdate.call(subscribedComponent.comp);
        }

        for (const subscribedObserver of this._subscribedReactObservers) {
            subscribedObserver();
        }
    }
}


// For React Functional Components
type UseZenAutoArtServiceResult<ServiceType> = (onChange?: () => void) => ServiceType;
export const createUseZenAutoArtService = <ServiceType>(service: SubscriberService<ServiceType>): UseZenAutoArtServiceResult<ServiceType> => {
    return (onChange?: () => void) => {
        const [, setDummy] = React.useState<{}>();

        const doOnChange = () => {
            setDummy({});
            if (onChange) {
                onChange();
            }
        }

        React.useEffect(() => {
            service["_subscribedReactObservers"].push(doOnChange);

            doOnChange();

            // Remove when unmounted
            return () => {
                service["_subscribedReactObservers"] = service["_subscribedReactObservers"].filter((update) => update !== doOnChange);
            };
        }, []);

        return service as ServiceType;
    }
};

export function createStaticServiceInstance<ServiceType>(inst: SubscriberService<ServiceType>, serviceName: string): ServiceType {
    window["_zaa_services"] = window["_zaa_services"] || {};
    window["_zaa_services"][serviceName] = inst; // Add to the window object to allow Blazor to interop.
    return inst as ServiceType;
}
